module.exports = __webpack_public_path__ + "static/6-a4ecb5143112ec2bdaa435f821fdc096.jpg";